import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Play, Download, Loader } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Loads an authenticated MP3 recording into a blob URL and renders an <audio> player + download.
export const RecordingPlayer = ({ callId, durationSeconds }) => {
  const { t } = useLanguage();
  const [blobUrl, setBlobUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => () => {
    if (blobUrl) URL.revokeObjectURL(blobUrl);
  }, [blobUrl]);

  const loadRecording = async () => {
    if (blobUrl || loading) return;
    setLoading(true);
    setErr('');
    try {
      const r = await axios.get(`${API}/recordings/${callId}`, {
        withCredentials: true,
        responseType: 'blob',
      });
      const url = URL.createObjectURL(r.data);
      setBlobUrl(url);
    } catch (e) {
      setErr(t('فشل تحميل التسجيل', 'Failed to load recording', 'Échec du chargement'));
    } finally {
      setLoading(false);
    }
  };

  const fmtMin = (sec) => {
    if (!sec) return '';
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  };

  if (!blobUrl) {
    return (
      <div className="mt-2 flex items-center gap-2" data-testid={`recording-player-${callId}`}>
        <Button size="sm" variant="outline" onClick={loadRecording} disabled={loading} data-testid={`recording-load-${callId}`}>
          {loading ? <Loader size={14} className="animate-spin me-1" /> : <Play size={14} className="me-1" />}
          {t('استماع للتسجيل', 'Listen to recording', "Écouter l'enregistrement")}
          {durationSeconds ? ` · ${fmtMin(durationSeconds)}` : ''}
        </Button>
        {err && <span className="text-xs text-red-500">{err}</span>}
      </div>
    );
  }

  return (
    <div className="mt-2 flex items-center gap-2 flex-wrap" data-testid={`recording-player-${callId}`}>
      <audio src={blobUrl} controls className="h-9 max-w-full" data-testid={`recording-audio-${callId}`} />
      <a href={blobUrl} download={`call-${callId}.mp3`} className="inline-flex" data-testid={`recording-download-${callId}`}>
        <Button size="sm" variant="ghost"><Download size={14} className="me-1" />{t('تحميل', 'Download', 'Télécharger')}</Button>
      </a>
    </div>
  );
};

export default RecordingPlayer;
